import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import Header from "./common/Header";
import Dashboard from "./dashboard/Dashboard";
import ResetPassword from "./common/ResetPassword";
import { config } from "../App";
import PaySlip from "./paySlip";
import Form16 from "./form16";
import WorkInProcess from "./common/WorkInProcess";
import ItComputation from "./itComputation";
import ReimbursementSlip from "./reimbursementSlip";
import AppraisalLatter from "./appraisalLetter";
import Footer from "./common/Footer";


function Layout() {

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      location.pathname.startsWith("/") &&
      location.pathname !== "/" &&
      !location.pathname.includes("/dashboard") &&
      !location.pathname.includes("/change-password") &&
      !location.pathname.includes("/paySlip") &&
      !location.pathname.includes("/reimbursementSlip") &&
      !location.pathname.includes("/itComputation") &&
      !location.pathname.includes("/form16") &&
      !location.pathname.includes("/work-inprosess") &&
      !location.pathname.includes("/appraisalLetter")
    ) {
      navigate("/dashboard", { replace: true });
    }

    if (location.pathname === "/") {
      navigate("/dashboard", { replace: true });
    }

  }, [location, navigate]);

  return (
    <div className="layout">
      <Header />

      <div className="app-container">
        <Routes>
          {/* <Route path="/" element={<Dashboard />} /> */}

          <Route
            path={`/dashboard`}
            element={<Dashboard />}
          />

          <Route
            path={`/change-password`}
            element={<ResetPassword />}
          />

          <Route
            path={`/paySlip`}
            element={<PaySlip />}
          />
          <Route
            path={`/reimbursementSlip`}
            element={<ReimbursementSlip />}
          />
          <Route
            path={`/itComputation`}
            element={<ItComputation />}
          />
          <Route
            path={`/form16`}
            element={<Form16 />}
          />
          <Route
            path={`/appraisalLetter`}
            element={<AppraisalLatter />}
          />

          <Route
            path={`/work-inprosess`}
            element={<WorkInProcess />}
          />
          <Route path="/*" element={<Dashboard />} />
        </Routes>
      </div>
      <Footer/>
    </div>
  );
}

export default Layout;